import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-listing-templates';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Listing Templates: The Secret to Top Sales</title>
        <meta
          name='description'
          content='Listing templates are the body text in the item that is for sale. Think of it as dedicated ad space for each item you are aiming to sell. You would want your copy to be short and engaging, informative but not stiff.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-listing-templates' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-listing-templates' />
        <meta property='og:title' content='Poshmark Listing Templates: The Secret to Top Sales' />
        <meta
          property='og:description'
          content='Listing templates are the body text in the item that is for sale. Think of it as dedicated ad space for each item you are aiming to sell. You would want your copy to be short and engaging, informative but not stiff.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
